module.exports = __webpack_public_path__ + "static/media/ec.e1ea3417.svg";